export default __webpack_public_path__ + "static/case-study-mobile-3c88f8d67a9a86d2460d5e46bf400e4e.png";